import React from 'react';
import './Blogs.css';
import blog1 from '../../../images/download (5).jpg';
import blog2 from '../../../images/download (5).jpg';

const Blogs = () => {
    return (
        <div className="Blogs">
            <div className="container py-5">
                <div className="header text-center">
                    <h2>MY LATEST <span>BLOG</span></h2>
                    {/* <p>I share the best ideas in my blog</p> */}
                    <div className="wrapper">
                        <div className="divider div-transparent div-dot"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={blog2} alt=""/>
                            <div className="card-body">
                                <h4 className="card-title">Coming Soon </h4>
                                {/* <span aria-label="" role="img">🔯</span> */}
                                <p className="card-text"> </p>
                                <a href="https://medium.com/@nurmuhammadd2001" target="_blank" rel="noopener noreferrer" className="btn">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="card mt-4">
                            <img className="card-img-top" src={blog1} alt=""/>
                            <div className="card-body">
                                <h4 className="card-title"> Coming Soon </h4>
                                {/* <span aria-label="" role="img">👓</span> */}
                                <p className="card-text"> </p>
                                <a href="https://medium.com/@nurmuhammadd2001" target="_blank" rel="noopener noreferrer" className="btn mr-10">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blogs;